import { useState, useEffect, useCallback } from "react";

export type CustomStatus = {
  message: string;
  emoji?: string;
  expiresAt?: string;
} | null;

export function useCustomStatus() {
  const [status, setStatus] = useState<CustomStatus>(null);
  const [loading, setLoading] = useState(true);

  // Carregar status salvo
  useEffect(() => {
    const loadStatus = () => {
      try {
        const saved = localStorage.getItem("adminCustomStatus");
        if (saved) {
          const parsed = JSON.parse(saved);
          // Verificar se expirou
          if (parsed.expiresAt && new Date(parsed.expiresAt) < new Date()) {
            localStorage.removeItem("adminCustomStatus");
            setStatus(null);
          } else {
            setStatus(parsed);
          }
        }
      } catch (error) {
        console.error("Error loading custom status:", error);
      } finally {
        setLoading(false);
      }
    };

    loadStatus();
  }, []);

  // Atualizar status
  const updateStatus = useCallback((newStatus: CustomStatus) => {
    setStatus(newStatus);
    if (newStatus) {
      localStorage.setItem("adminCustomStatus", JSON.stringify(newStatus));
    } else {
      localStorage.removeItem("adminCustomStatus");
    }
  }, []);

  // Limpar status expirado
  useEffect(() => {
    if (status?.expiresAt) {
      const expiresAt = new Date(status.expiresAt);
      const now = new Date();
      const timeout = expiresAt.getTime() - now.getTime();

      if (timeout > 0) {
        const timer = setTimeout(() => {
          setStatus(null);
          localStorage.removeItem("adminCustomStatus");
        }, timeout);

        return () => clearTimeout(timer);
      } else {
        setStatus(null);
        localStorage.removeItem("adminCustomStatus");
      }
    }
  }, [status]);

  return {
    status,
    loading,
    updateStatus,
  };
}
